import React, { SyntheticEvent } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { CompanyBaseExtended } from "../../../Utils/TypeExtensions";
import { StringCustomControlProps } from "../../../Utils/Interfaces";
import { useLiveQuery } from "dexie-react-hooks";
import { TicketDatabase } from "../../../Utils/TicketDatabase";
import { CONTROL_MARGIN } from "../../../MuiThemes";
import { getHelperText, propertyHasErrors } from "../inputHelpers";

export default function BaseLocationSelector(props: StringCustomControlProps): JSX.Element {
    const baseLocationList = useLiveQuery(async () => TicketDatabase.companyBase.toArray());

    if (!baseLocationList) return <></>;

    function handleOnChange(e: SyntheticEvent, value: string | CompanyBaseExtended | null) {
        let newValue;
        if (value !== null) {
            newValue = (value as CompanyBaseExtended).airport_code;
        }

        props.mergeChanges(props.sourceId, { [props.sourceProperty]: newValue });
    }

    let sortedByName = [] as CompanyBaseExtended[];

    sortedByName = baseLocationList.sort((a: CompanyBaseExtended, b: CompanyBaseExtended) => {
        return (a.selectName ?? "").localeCompare(b.selectName ?? "");
    });

    const initialValue = baseLocationList.find((p) => p.airport_code === props.initialValue);

    return (
        <>
            <Autocomplete
                disabled={props.isDisabled}
                value={initialValue === undefined ? null : initialValue}
                options={sortedByName}
                onChange={handleOnChange}
                getOptionLabel={(option: CompanyBaseExtended) => option.selectName ?? ""}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        required={props.isRequired}
                        error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                        margin={CONTROL_MARGIN}
                        label={props.labelText}
                        placeholder="type to search"
                    />
                )}
            />
        </>
    );
}
